import HFHeader from "@/components/HFHeader";
import HFFooter from "@/components/HFFooter";
import { Container } from "@/components/ui-hf";
import { BDV_KONTAKT_DEFAULT } from "@/lib/legalContent";
import { useSiteContent } from "@/lib/siteContent";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Helmet } from "react-helmet-async";

export default function BdvKontaktPage() {
    const { get } = useSiteContent();
    const markdown = (get<string>("legal.bdv_kontakt", "").trim() || BDV_KONTAKT_DEFAULT).trim();
    const canonical =
        typeof window !== "undefined" ? `${window.location.origin}/bdv-kontakt` : "/bdv-kontakt";

    return (
        <div className="min-h-screen">
            <Helmet>
                <title>Kontakt · BDV GmbH – HypeFly</title>
                <meta
                    name="description"
                    content="Kontaktdaten der BDV Büroservice Dienstleistungs- Vermittlungs GmbH — Muttergesellschaft der Marke HypeFly. Düsseldorf, Grafenberger Allee 293."
                />
                <link rel="canonical" href={canonical} />
            </Helmet>
            <HFHeader />
            <main id="main-content" data-testid="bdv-kontakt-main">
                <Container className="pt-16 md:pt-28 pb-20 md:pb-32 max-w-3xl">
                    <article className="prose max-w-none text-hf-ink" data-testid="bdv-kontakt-markdown">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
                    </article>
                </Container>
            </main>
            <HFFooter />
        </div>
    );
}
